import {OnInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {AppService} from "@api";

import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {AlertaEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import {UsuarioService} from '@servicios/Usuario.service';
import {AlineacionImagenEnum} from "@componentes/Enums.enum";

import {AlumnoComponent} from '@contenido/AppContent/evaluacionpendiente/alumno/alumno.component';

@Component(
    {
        selector: 'evaluacionemail',
        templateUrl: './evaluacionemail.component.html',
        styleUrls: ['./evaluacionemail.component.scss']
    })

export class EvaluacionEmailComponent implements OnInit {
    consulta!: boolean;
    urlTree: any;
    username: any;

    listaalumno: any[];
    alumnoseleccionado: any;
    Periodo: any[];

    public AlineacionImagenEnum = AlineacionImagenEnum;

    @ViewChild("containerEvaluacion", {read: ViewContainerRef}) containerEvaluacion!: ViewContainerRef;

    constructor(private route: ActivatedRoute, private appService: AppService, public usuarioService: UsuarioService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
        this.listaalumno = [];
        this.Periodo = [];
    }

    ngOnInit() {
        let token = this.route.snapshot.paramMap.get('token');
        let data = {token: token};
        this.appService.Post("auth/loginlink", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.sistemaService.datosInicialesCargados = true;
                localStorage.setItem(this.sistemaService.localStoreVariable.JWT, res.data.token);
                this.setAlumno();
            }
            else {
                this.usuarioService.CerrarSesion();
            }
        });

    }

    setAlumno() {
        let token = this.route.snapshot.paramMap.get('token');
        this.appService.Post("evaluacionpendiente/alumno/alumnobuscar", {"url": token}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                if (res.data) {
                    this.listaalumno = res.data.alumnos;
                    this.Periodo = res.data.periodoevaluacion;

                } else {
                    this.mensajeService.Alerta(AlertaEnum.Warning, res.message);
                }
            }
        })
    }

    Buscaralumno(e: any) {
        this.alumnoseleccionado = e;
    }

    Formulario(data: any) {
        this.cargarContenedorFormulario({data: data});

    }

    //Carga el contenedor con la informacion de la evaluacion
    cargarContenedorFormulario(data: {data: any}) {
        this.consulta = true;
        this.containerEvaluacion.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AlumnoComponent);
        var ref: ComponentRef<any> = this.containerEvaluacion.createComponent(factory);
        ref.instance.entidad = data.data;
        ref.instance.valores = this.Periodo;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if (cambio) {
            }
        });
    }
}